import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./reset.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./router";
import Fixed from "./components/linksSocialFixed/index";
import Header from "./components/Header/index";
import ReactPixel from "react-facebook-pixel";
import GA4React from "ga-4-react";
import TagManager from "react-gtm-module";
ReactPixel.init("809503810598473", {});

function Manager() {
  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-PSPFRSN" });
  }, []);
}

function FacebookPixel() {
  React.useEffect(() => {
    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init("809503810598473");
        ReactPixel.pageView();

        Router.events.on("routeChangeComplete", () => {
          ReactPixel.pageView();
        });
      });
  });
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <FacebookPixel />
        <Manager />
        <Header />
        <Fixed />
        <Router />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

try {
  setTimeout((_) => {
    const ga4react = new GA4React("G-5Y075YFGMZ");
    ga4react.initialize().catch((err) => console.error(err));
  }, 4000);
} catch (err) {
  console.error(err);
}
